import { Box, FormControlLabel, ListItemIcon, styled } from '@mui/material';
import MenuItem from '../MenuItem';
import React, { MouseEventHandler, MutableRefObject } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTheme } from '@mui/material/styles';
import { ReactComponent as CheckIcon } from 'ui/assets/checkmark.svg';
import { Checkbox } from '../Checkbox/index';

export const MenuListItemItemComponent = styled(MenuItem, {
  name: 'MenuListItemItemComponent',
  shouldForwardProp: prop => prop !== 'hasSubItems'
})<{ hasSubItems?: boolean }>(({ theme, hasSubItems }) => {
  const { fontSize, fontWeight, lineHeight } = theme.typography.body4;

  return {
    padding: theme.spacing(1, hasSubItems ? 0 : 1, 1, 1),
    marginBottom: theme.spacing(0.5),
    borderRadius: theme.spacing(1),
    fontSize,
    fontWeight,
    lineHeight,
    color: theme.palette.grey[200],
    '&:hover, &.Mui-focusVisible:hover': {
      backgroundColor: theme.palette.transparent.primary[32],
      color: theme.palette.common.white
    },
    '&:last-of-type': { marginBottom: 0 },
    '&.Mui-focusVisible': { color: theme.palette.grey[200], backgroundColor: theme.palette.grey[500] }
  };
});

export const SelectedSubItemsIndicator = styled(Box, { name: 'SelectedSubItemsIndicator' })(({ theme }) => ({
  width: theme.spacing(0.5),
  height: theme.spacing(0.5),
  backgroundColor: theme.palette.grey[200],
  position: 'absolute',
  left: theme.spacing(-1),
  top: 'calc(50% - 2px)',
  borderRadius: '50%'
}));

export const SubItemsIndicator = ({
  hasSubItems,
  innerRef
}: {
  hasSubItems?: boolean;
  innerRef: MutableRefObject<HTMLLIElement | null>;
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center' }} ref={innerRef}>
    {hasSubItems && (
      <ListItemIcon sx={{ justifyContent: 'right' }}>
        <ChevronRightIcon
          sx={theme => ({
            color: theme.palette.grey[200],
            wight: theme.spacing(2),
            height: theme.spacing(2),
            '&:hover': { color: theme.palette.common.white }
          })}
        />
      </ListItemIcon>
    )}
  </Box>
);

export const SelectionCheckItem = ({ isSelected, isHovering }: { isSelected?: boolean; isHovering: boolean }) => {
  const theme = useTheme();
  return isSelected ? (
    <CheckIcon
      style={{
        color: isHovering ? theme.palette.common.white : theme.palette.grey[200],
        width: theme.spacing(1.75),
        height: theme.spacing(1.75),
        marginRight: theme.spacing(1.75)
      }}
    />
  ) : (
    <Box sx={{ width: theme.spacing(1.75), height: theme.spacing(1.75), marginRight: theme.spacing(1.75) }} />
  );
};

export const CheckBoxWithLabel = ({
  text,
  isSelected,
  onClick
}: {
  text?: string;
  isSelected?: boolean;
  onClick?: MouseEventHandler<HTMLLIElement | HTMLButtonElement>;
}) => (
  <FormControlLabel
    label={text}
    control={
      <Checkbox
        iconWidth={18}
        iconHeight={18}
        disableRipple
        checked={isSelected}
        onClick={event => {
          event.stopPropagation();
          onClick?.(event);
        }}
      />
    }
    sx={theme => {
      const { fontSize, fontWeight, lineHeight } = theme.typography.body2;

      return { width: '100%', '& .MuiFormControlLabel-label': { fontSize, fontWeight, lineHeight } };
    }}
    onClick={event => {
      event.stopPropagation();
    }}
  />
);
